import { Helmet } from "react-helmet-async";

// Canonical/OG host for human-facing tags. Kept in sync with lib/jsonld SITE_URL
// (the www host is the single canonical domain) so canonical tags and JSON-LD
// @id/url values never disagree. All head tags are emitted through
// react-helmet-async so the react-snap prerender step bakes them into the
// static HTML.
const SITE_URL = "https://www.autocarex.in";
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;
const abs = (u) => (!u ? DEFAULT_IMAGE : u.startsWith("http") ? u : `${SITE_URL}${u}`);

export const Seo = ({
  title,
  description,
  image,
  jsonLd,
  type = "website",
  noindex = false,
  imageAlt,
}) => {
  const fullTitle = title ? `${title} | AutoCareX` : "AutoCareX — Intelligent Car Care";
  const pathname = typeof window !== "undefined" ? window.location.pathname : "/";
  const url = `${SITE_URL}${pathname}`;
  const img = abs(image);
  const robots = noindex ? "noindex, follow" : "index, follow";
  const blocks = (Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []).filter(Boolean);

  return (
    <Helmet>
      <html lang="en-IN" />
      <title>{fullTitle}</title>
      <meta name="description" content={description || ""} />
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || ""} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:alt" content={imageAlt || fullTitle} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:site_name" content="AutoCareX" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || ""} />
      <meta name="twitter:image" content={img} />
      <meta name="twitter:image:alt" content={imageAlt || fullTitle} />

      <link rel="canonical" href={url} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
